import { Tooltip } from '@mui/material';
import { ellipsis } from '../util/StringUtil';

type AutoEllipsisProps = {
  text: string | undefined;
  maxLength: number;
};

export const AutoEllipsis = (props: AutoEllipsisProps) => {
  const { maxLength, text } = props;
  if (!text || text.length < maxLength) {
    return <span>{text}</span>;
  }
  return (
    <Tooltip title={text}>
      <span>{ellipsis(text, maxLength)}</span>
    </Tooltip>
  );
};
